import MessageBus from 'q2-tecton-common/lib/utility/message-bus';
import { Maybe } from 'maybe-not';
import { TectonWindow } from '../types';

declare var window: TectonWindow;

export default function setupGlobalVars(
    messageBus: MessageBus,
    capabilities: Set<string>
): Promise<void> {
    if (capabilities.has('getPlatformInfo')) {
        return messageBus
            .sendRequest<{
                PLATFORM_VERSION: string;
                FI_IDENTIFIER: string;
                TECTON_PLATFORM_VERSION: string;
                inMobileApp: boolean;
            }>('getPlatformInfo', Maybe.nothing())
            .then(response => {
                window.Tecton = {
                    ...window.Tecton,
                    ...response.value,
                    TECTON_SDK_VERSION: TECTONSDKVERSION
                };
            });
    }
    return messageBus
        .sendRequest<{
            PLATFORM_VERSION: string;
            FI_IDENTIFIER: string;
            TECTON_PLATFORM_VERSION: string;
            UUX_VERSION?: string;
        }>('getUUXInfo', Maybe.nothing())
        .then(response => {
            window.Tecton = {
                ...window.Tecton,
                ...response.value,
                PLATFORM_VERSION:
                    response.value.PLATFORM_VERSION || response.value.UUX_VERSION || '',
                TECTON_SDK_VERSION: TECTONSDKVERSION
            };
        });
}
